let lockCount = 0;

export function lock(): void {
  lockCount++;
  if (lockCount === 1) {
    document.body.classList.add('modal-open');
  }
}

export function unlock(): void {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    document.body.classList.remove('modal-open');
  }
}

export function isLocked(): boolean {
  return lockCount > 0;
}

export function reset(): void {
  lockCount = 0;
  document.body.classList.remove('modal-open');
}
